// orderSlice.ts
import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { OrderService } from "../services/OrderService";
import { IOrder } from "../types/IOrder";

// Define the state type
interface OrderState {
    orders: IOrder[];
    loading: boolean;
    error: string | null;
}

// Initial state
const initialState: OrderState = {
    orders: [],
    loading: false,
    error: null,
};

// Async thunk for fetching orders
export const fetchOrders = createAsyncThunk("orders/fetchOrders", async () => {
    const orders = await OrderService.getAllOrders();
    return orders;
});

export const updateOrder = createAsyncThunk<
    void,
    { orderId: string; updatedOrderData: Partial<IOrder> }
>("orders/updateOrder", async ({ orderId, updatedOrderData }) => {
    await true;
});

// Slice
const orderSlice = createSlice({
    name: "orders",
    initialState,
    reducers: {
        resetOrders(state) {
            state.orders = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOrders.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOrders.fulfilled, (state, action: PayloadAction<IOrder[]>) => {
                state.orders = action.payload;
                state.loading = false;
            })
            .addCase(fetchOrders.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to fetch orders";
            }).addCase(updateOrder.pending, (state) => {
                // Optionally set a loading state for the update operation
            })
            .addCase(updateOrder.fulfilled, (state, { meta }) => {
                // Find the order in the state and update it 
                const orderIndex = state.orders.findIndex((order) => order.id === meta.arg.orderId);
                if (orderIndex !== -1) {
                    state.orders[orderIndex] = {
                        ...state.orders[orderIndex],
                        ...meta.arg.updatedOrderData,
                    };
                }
            })
            .addCase(updateOrder.rejected, (state, action) => {
                // Handle update failure (e.g., display an error message)
                state.error = action.error.message || "Failed to update order";
            });;
    },
});

export const { resetOrders } = orderSlice.actions;
export default orderSlice.reducer;
